import React, { useEffect, useState } from 'react';
import { Card, message } from 'antd';
import DetailItem from '../../../components/Detail/Item';
import axios from '../../../util/Api';

const Detail = ({ id }) => {
  const [loading, setLoading] = useState(true);
  const [vendor, setVendor] = useState({});

  useEffect(() => {
    setLoading(true);
    const url = `/vendor/detail?id=${id}`;
    axios.get(url).then(resp => {
      setVendor(resp.data);
      setLoading(false);
    }).catch(err => {
      message.error("Gagal memuat data perusahaan");
    });
  }, [id]);
  return (
    <Card className="gx-card">
      <div className="gx-text-md gx-mb-4">Detail Perusahaan</div>
      {loading ? "Sedang memuat..." : (
        <>
          <DetailItem label="Nama Perusahaan" value={vendor.name} />
          <DetailItem label="Kode Perusahaan" value={vendor.code} />
          <DetailItem label="Kategori Perusahaan" value={vendor.category.label} />
          <DetailItem label="Jenis Perusahaan" value={vendor.type.label} />
          <DetailItem label="Divisi Perusahaan" value={vendor.division.label} />
          <DetailItem label="Email" value={vendor.email} />
          <DetailItem label="Nomor Telepon/WA" value={vendor.phone} />
        </>
      )}
    </Card>
  )
}

export default Detail;